/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitCountFindingsInterval } from './MonitCountFindingsInterval';
import {
    MonitCountFindingsIntervalFromJSON,
    MonitCountFindingsIntervalFromJSONTyped,
    MonitCountFindingsIntervalToJSON,
} from './MonitCountFindingsInterval';

/**
 * 
 * @export
 * @interface CountFindingsFilter
 */
export interface CountFindingsFilter {
}

/**
 * Check if a given object implements the CountFindingsFilter interface.
 */
export function instanceOfCountFindingsFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CountFindingsFilterFromJSON(json: any): CountFindingsFilter {
    return CountFindingsFilterFromJSONTyped(json, false);
}

export function CountFindingsFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountFindingsFilter {
    return json;
}

export function CountFindingsFilterToJSON(value?: CountFindingsFilter | null): any {
    return value;
}

